import React, { useState, useRef, useEffect ,forwardRef, useImperativeHandle} from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import { useParams, Link, useNavigate } from 'react-router-dom';

import InviteCustomer31 from '../../jsx/constant/ArbonAmount';
import InviteCustomer3 from '../../jsx/constant/RestAmount';
     const CreateVehicleRepairRecord = forwardRef((props, ref) => {

  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
    const [report, setreport] = useState({})
    const [data3, setData3] = useState({});

    const [formData, setFormData] = useState({
    VehicleID: '',
    CustomerID: '',
    RepairDate: '',
    Prepay:'0.00',
    TotalCost:'',
    RepairStatus: 'انتظار',
   // TechnicianID: '',
   // LaborHours: '',
   ServiceCost: '',
   // Notes: '',
   // PartQuantities: '',
     Discount: 0, // ✅ الخصم
    PartCost: '',
    TotalunitPrice:'',
    CheckPrice:0,
       UserID:userid,
       Notes:'',
       Km:'',
  });
  const invite31 = useRef();
  const invite3 = useRef();
  const navigate = useNavigate();
    const [baseAmount, setbaseAmount] = useState('');

  const [TotalAmount, setTotalAmount] = useState('');
  const [TotalunitPrice, setTotalunitPrice] = useState('');

  const [customers, setCustomers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [data, setData] = useState([]);
  const [services, setServices] = useState([]);
  const [parts, setParts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedParts, setSelectedParts] = useState([]);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    const fetchCustomers = async () => {
      const response = await axios.get('https://subk.education.com.ly/back/api/customers');
      setCustomers(response.data);
    };

    

    const fetchServices = async () => {
      const response = await axios.get('https://subk.education.com.ly/back/api/services');
      setServices(response.data);
    };

  //  const fetchParts = async () => {
   //   const response = await axios.get('https://subk.education.com.ly/back/api/parts');
  //    setParts(response.data);
  //};

    fetchCustomers();
     fetchServices();
    //fetchParts();
  }, []);

  const handleCustomerChange = async (e) => {
    const customerId = e.target.value;
    setFormData({ ...formData, CustomerID: customerId });

    const response = await axios.get(`https://subk.education.com.ly/back/api/getVehiclesByCustomer/${customerId}`);
    setVehicles(response.data);
  };
 const handleCustomercarChange = async (e) => {
  const VehicleID = e.target.value;

  // تحديث VehicleID أولاً
  setFormData((prev) => ({
    ...prev,
    VehicleID: VehicleID,
  }));

  try {
    const response = await axios.get(
      `https://subk.education.com.ly/back/api/getKmByCar/${VehicleID}`
    );

    // تحديث Km باستخدام prev أيضاً
    setFormData((prev) => ({
      ...prev,
      Km: response.data[0]?.Odometer || "",
    }));

  } catch (error) {
    console.error(error);
  }
};

  const [partModal, setPartModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
        setPartModal(true)
    }}));
const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (name === "CheckPrice") {
    setTotalAmount(baseAmount + Number(value || 0));
  }
};
    const [Notes, setNotes] = useState('')



const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission
  
  console.log('Selected Services:', selectedService);
  console.log('Selected Parts:', selectedParts);
 
  // Check if selectedServices and selectedParts are non-empty arrays
  if (!selectedService || selectedService.length === 0) {
      console.error('No services selected.');
  }
  
  if (!selectedParts || selectedParts.length === 0) {
      console.error('No parts selected.');
  }
  const repairOrderData = {
    CustomerID: formData.CustomerID,
    RepairDate: formData.RepairDate,
    VehicleID: formData.VehicleID,
    UserID: formData.UserID,
    TotalCost: TotalAmount,
    CheckPrice:formData.CheckPrice,
    TotalunitPrice: TotalunitPrice,
    Prepay: formData.Prepay,
    Notes:formData.Notes,
    Discount:formData.Discount,
    Km:formData.Km,
    repairDetails: [
        // Add selected parts to repairDetails
        ...selectedParts.map(part => {
            // Ensure PartCost is a valid number and has only 2 decimal places
            let partCost = parseFloat(part.PartCost);

            // Check if partCost is a valid number
            if (isNaN(partCost)) {
                partCost = 0; // If not valid, set it to 0
            } else {
                partCost = partCost.toFixed(2); // Round to 2 decimal places
            }

            // Convert back to a number
            partCost = parseFloat(partCost);

            return {
                PartID: part.PartID,
                PartQuantities: part.quantity,
                PartCost: partCost,
                PurchasePrice: part.PurchasePrice
            };
        }),

        // Add selected services to repairDetails
        ...selectedService.map(service => ({
            ServiceID: service.ServiceID,
            TechnicianID: formData.TechnicianID, // Assuming this field is selected in your form
            LaborHours: formData.LaborHours,     // Assuming this field is from your form
            ServiceCost: service.StandardPrice	// Assuming service cost is part of each service object
        }))
    ],
};

  // Prepare repair order data
//   const repairOrderData = {
//       CustomerID: formData.CustomerID,
//       RepairDate: formData.RepairDate,
//       VehicleID: formData.VehicleID,
//       UserID:formData.UserID  ,
//       TotalCost:TotalAmount,
//       TotalunitPrice:TotalunitPrice,
//       Prepay:formData.Prepay,
//          repairDetails: [
//           // Add selected parts to repairDetails
//           ...selectedParts.map(part => ({
//               PartID: part.PartID,
//               PartQuantities: part.quantity,
//               PartCost:part.PartCost,
//               PurchasePrice:part.PurchasePrice
//           })),
          
//           // Add selected services to repairDetails
//           ...selectedService.map(service => ({
//               ServiceID: service.ServiceID,
//               TechnicianID: formData.TechnicianID, // Assuming this field is selected in your form
//               LaborHours: formData.LaborHours,     // Assuming this field is from your form
//               ServiceCost: service.StandardPrice	,    // Assuming service cost is part of each service object
//           }))
//       ],
//   };

  // Log the full repairOrderData for debugging purposes
  console.log('Repair Order Data to be Sent:', repairOrderData);

  try {
      // Send the complete data to the API
      const response = await fetch('https://subk.education.com.ly/back/api/repairOrder', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(repairOrderData), // Send the repairOrderData
      });

      const result = await response.json();
      
      if (response.ok) {
        toast.success('!تم الاضافة بنجاح');
        setData(result.RepairOrder)
// const SecqueryString = new URLSearchParams({
//     data: JSON.stringify(result.RepairOrder.repair_details), // Ensure safe URL encoding
//     data2: JSON.stringify(result.RepairOrder.invoice), // Ensure safe URL encoding

//     name: result.RepairOrder.customer.FirstName,
//     RefNmber: '000000',
//     TotalCost: result.RepairOrder.TotalCost,
//     Vehicle: result.RepairOrder.vehicle.LicensePlate,
//     RepairDate: result.RepairOrder.RepairDate,
//     Prepay:result.RepairOrder.Prepay,
//     CheckPrice:result.RepairOrder.CheckPrice,
//     InvoiceType:'مبدئية'

// }).toString();
 // Navigate with the query string
navigate(`/Invoice?repairOrderId=${result.RepairOrder.RepairOrderID}`);      } else {
          console.error('Error saving repair order:', result.message);
                  toast.warning( result.message);

      }
  } catch (error) {
      console.error('Error:', error);
  }
};

 

  const [categories, setCategories] = useState([]);
   const [selectedCategory, setSelectedCategory] = useState(null);
  const [formData1, setFormData1] = useState({
      categoryId: '', // Example form data structure
      serviceId: '',
  });

  useEffect(() => {
      // Fetch categories on component mount
      const fetchCategories = async () => {
          try {
              const response = await axios.get('https://subk.education.com.ly/back/api/getServiceCategory'); // Adjust to your actual API URL
              setCategories(response.data);
          } catch (error) {
              console.error('Error fetching categories:', error);
          }
      };
      fetchCategories();
  }, []);


  
  const [selectedService, setSelectedService] = useState([]); // New state for selected service
  const [expandedCategoryId, setExpandedCategoryId] = useState(null); // Track which category is expanded
  const handleCategoryChange = async (category) => {
    const categoryId = category.servicecategoryID;

    // If the clicked category is already expanded, close it
    if (expandedCategoryId === categoryId) {
        setExpandedCategoryId(null);
        setServices([]); // Clear services if category is collapsed\
       // setSelectedService([]); // Reset selected service when collapsing
    } else {
        setExpandedCategoryId(categoryId);
        // Fetch services related to the selected category
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/ServiceCategory/${categoryId}`); // Adjust your API endpoint accordingly
            setServices(response.data); // Assuming the API returns an array of services
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    } 
   
};
const handleServiceSelect = (service) => {
  setSelectedService((prevSelectedService) => {
      // Check if the service is already selected
      const isSelected = prevSelectedService.some(selected => selected.ServiceID === service.ServiceID);
      
      if (isSelected) {
          // Remove the service from selected services
          return prevSelectedService.filter(selected => selected.ServiceID !== service.ServiceID);
      } else {
          // Add the service to selected services
          return [...prevSelectedService, service];
      }
  });
  console.log('selectedParts',selectedParts)

};          
useEffect(() => {
  // Calculate total for services
  const serviceTotal = selectedService.reduce(
    (sum, part) => sum + (parseFloat(part.StandardPrice) || 0),
    0
  );

  // Calculate total for parts
  const partsTotal = selectedParts.reduce(
    (sum, part) =>
      sum + (parseFloat(part.quantity) || 0) * (parseFloat(part.PurchasePrice) || 0),
    0
  );

  const partsTotalunitPrice = selectedParts.reduce(
    (sum, part) =>
      sum + (parseFloat(part.quantity) || 0) * (parseFloat(part.Cost) || 0),
    0
  );

  setTotalunitPrice(partsTotalunitPrice);

  const CheckPrice = parseFloat(formData.CheckPrice) || 0;

  // Save the base separately if you need it
  setbaseAmount(serviceTotal + partsTotal);

  // ✅ Always include check price in the final total
  setTotalAmount(serviceTotal + partsTotal + CheckPrice);

}, [selectedService, selectedParts, formData.CheckPrice]);

// useEffect(() => {
//     // Calculate total for services
//     const serviceTotal = selectedService.reduce((sum, part) => 
//         sum + (parseFloat(part.StandardPrice) || 0), 0
//     );
//     console.log('se',selectedParts);

//     // Calculate total for parts
//     const partsTotal = selectedParts.reduce((sum, part) => 
//         sum + (parseFloat(part.quantity) || 0) * (parseFloat(part.PurchasePrice) || 0), 0
//     );
//     const partsTotalunitPrice = selectedParts.reduce((sum, part) => 
//         sum + (parseFloat(part.quantity) || 0) * (parseFloat(part.Cost) || 0), 0
    
//     );
//     // Set the combined total amount
//     setTotalunitPrice(partsTotalunitPrice);
// setbaseAmount(serviceTotal + partsTotal);
//     setTotalAmount(serviceTotal + partsTotal);
// console.log('partsTotalunitPrice',partsTotalunitPrice);
// console.log('partsTotal',partsTotal);


// }, [selectedService, selectedParts]);
//-------------------------part---------------------------
const [partClasses, setPartClasses] = useState([]);

useEffect(() => {
  const fetchPartClasses = async () => {
      try {
          const response = await axios.get('https://subk.education.com.ly/back/api/getPartClacess'); // Adjust your API URL
          setPartClasses(response.data);
      } catch (error) {
          console.error('Error fetching part classes:', error);
      }
  };
  fetchPartClasses();
}, []);
    const [expandedPartClassId, setExpandedPartClassId] = useState(null); // Track which part class is expanded
 // Fetch parts when a part class is selected
   

    // Handle part class selection
    const handlePartClassChange = async (partClass) => {
        const partClassId = partClass.PartClassID;

        // Toggle part class expansion
        if (expandedPartClassId === partClassId) {
            setExpandedPartClassId(null);
            setParts([]); // Clear parts if part class is collapsed
            //setSelectedParts([]); // Reset selected parts when collapsing
        } else {
            setExpandedPartClassId(partClassId);
            try {
              const response = await  axios.get(`https://subk.education.com.ly/back/api/partclasses/${partClass.PartClassID}`); // Adjust your API URL
              setParts(response.data);
              console.log('response.data',response.data);
          } catch (error) {
              console.error('Error fetching parts:', error);
          }
        }
    };

    // Handle part selection (checkboxes)
    const handlePartSelecte = (part) => {
        setSelectedParts((prevSelectedParts) => {
            const isSelected = prevSelectedParts.some(selected => selected.PartID === part.PartID);
            if (isSelected) {
                // Remove part if already selected
                return prevSelectedParts.filter(selected => selected.PartID !== part.PartID);
            } else {
                // Add part to selected parts
                return [...prevSelectedParts, part];
            }
        });
    };
    // Initial state for selected parts with quantity

// Handle part selection
const handlePartSelect = (part) => {
    const partExists = selectedParts.some(selected => selected.PartID === part.PartID);

    if (partExists) {
        // If part is already selected, remove it from selectedParts
        setSelectedParts(selectedParts.filter(selected => selected.PartID !== part.PartID));
    } else {
        // Add the part with a default quantity of 1
        setSelectedParts([...selectedParts, { ...part, quantity: 1 }]);
    }
    console.log('selectedParts',selectedParts)

};

// Handle quantity change for a part
const handleQuantityChange = (partID, quantity) => {
    setSelectedParts(
        selectedParts.map(selected => 
            selected.PartID === partID ? { ...selected, quantity: parseInt(quantity) } : selected
        )
    );
};

// Get the quantity of a selected part
const getPartQuantity = (partID) => {
    const selectedPart = selectedParts.find(selected => selected.PartID === partID);
    return selectedPart ? selectedPart.quantity : 1; // Default quantity is 1
};
useEffect(() => {
  // مجموع الخدمات
  const serviceTotal = selectedService.reduce(
    (sum, service) => sum + (parseFloat(service.StandardPrice) || 0),
    0
  );

  // مجموع قطع الغيار (سعر البيع)
  const partsTotal = selectedParts.reduce(
    (sum, part) =>
      sum +
      (parseFloat(part.quantity) || 0) *
      (parseFloat(part.PurchasePrice) || 0),
    0
  );

  // مجموع تكلفة القطع (للوحدة)
  const partsTotalunitPrice = selectedParts.reduce(
    (sum, part) =>
      sum +
      (parseFloat(part.quantity) || 0) *
      (parseFloat(part.Cost) || 0),
    0
  );

  setTotalunitPrice(partsTotalunitPrice);

  const checkPrice = parseFloat(formData.CheckPrice) || 0;
  const discount = parseFloat(formData.Discount) || 0;

  const baseTotal = serviceTotal + partsTotal + checkPrice;

  // ✅ لا تسمح أن يكون الخصم أكبر من المجموع
  const finalTotal = Math.max(baseTotal - discount, 0);

  setbaseAmount(baseTotal);
  setTotalAmount(finalTotal);

}, [selectedService, selectedParts, formData.CheckPrice, formData.Discount]);

  return (
    <>
    <Modal show={partModal}   size="xl" centered>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5">عملية صيانة جديدة</h1>
          <Link to='#' type="button" style={{ marginLeft: 0 }} className="btn-close" onClick={()=> setPartModal(false)} ></Link>

          </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {errors && <div className="alert alert-danger">{errors}</div>}
            <div className="row">
              <div className="col-xl-3  mt-3 d-flex">
                <label className="form-label mt-1  ms-3">الزبون</label>
                <select
                  className="form-control"
                  id="CustomerID"
                  name="CustomerID"
                  value={formData.CustomerID}
                  onChange={handleCustomerChange}
                  required
                >
                  <option value="">اختر</option>
                  {customers.map((customer) => (
                    <option key={customer.CustomerID} value={customer.CustomerID}>
                      {customer.FirstName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-xl-3 mt-3 d-flex">
                <label className="form-label mt-1  ms-3 ">السيارة</label>
                <select
                  className="form-control"
                  id="VehicleID"
                  name="VehicleID"
                  value={formData.VehicleID}
                  onChange={handleChange}
                  required
                >
                  <option value="">اختر</option>
                  {vehicles.map((vehicle) => (
                    <option key={vehicle.VehicleID} value={vehicle.VehicleID}>
                    {vehicle.make.MakeName}  - {vehicle.vehicle_model.ModelName} -  {vehicle.EngineNumber} - {vehicle.LicensePlate}
                        
                    </option>
                  ))}
                </select>
              </div>
          
<div className="col-xl-2 mt-3 d-flex">
                <label htmlFor="Km" className="form-label mt-1  ms-3"style={{ whiteSpace: "nowrap" }}>العداد</label>
                <input type="number" className="form-control" id="Km" required name="Km" defaultValue={formData.Km} onChange={handleChange}   />
              </div>
               <div className="col-xl-3 mt-3 d-flex">
                <label htmlFor="RepairDate" className="form-label mt-1  ms-3"style={{ whiteSpace: "nowrap" }}>تاريخ الصيانة</label>
                <input type="date" className="form-control" id="RepairDate" required name="RepairDate" value={formData.RepairDate} onChange={handleChange}   />
              </div>
                             <div className="col-xl-3  mt-3 d-flex">
 
              <label htmlFor="RepairDate" className="form-label mt-1  ms-3"style={{ whiteSpace: "nowrap" }}>سعر الكشف</label>
                <input type="number" className="form-control" id="CheckPrice" required name="CheckPrice" value={formData.CheckPrice} onChange={handleChange}   />
              </div> 
              <div className="col-xl-3 mt-3 d-flex">
  <label className="form-label  ms-3" style={{ whiteSpace: "nowrap" }}>
    التخفيض
  </label>
  <input
    type="number"
    className="form-control"
    id="Discount"
    name="Discount"
    min="0"
    value={formData.Discount}
    onChange={handleChange}
  />
</div>

              <div className="col-xl-2 mt-3 d-flex">
                <label htmlFor="TotalAmount" className="form-label    ms-3"style={{ whiteSpace: "nowrap" }}>المجموع</label>
             
              <div className="basic-form">
                  <form action="#">
                    <div className="input-group mb-3">
                         <span className="input-group-text primary" style={{ direction: "ltr",  
  width:'100px',
  height: '2.5rem '}}>${TotalAmount}</span>
                       
                      
                        </div>

                    
                  </form>
                </div>
               </div> 
                 <div className="col-md-4 mt-3">
                        <div className="    d-flex ">
                            <p><> ملاحظات:</> </p>
                            <textarea
                 className="form-control mx-3 sm"
                 value={formData.Notes}
                 name="Notes"
onChange={handleChange}               />
                              
                                </div></div>
               </div> 

                    <div className="row">
                    <div className="col-xl-6">

                    <label className="form-label mt-3" style={{ whiteSpace: "nowrap" }}>اختر الخدمة:</label>
                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
    {categories.map(category => (
        <div key={category.servicecategoryID}>
            <div 
                onClick={() => handleCategoryChange(category)} 
                style={{ 
                    //color:'white',
                    cursor: 'pointer', 
                    margin: '10px 0', 
                    padding: '10px', 
                    border: '1px solid #ccc', 
                 //   background: expandedCategoryId === category.servicecategoryID ?  'rgb(37, 50, 78);' :' rgb(24, 34, 55)' // Highlight if expanded
                }}
            >
                <span style={{ marginleft: '10px' }}>
                    {expandedCategoryId === category.servicecategoryID ? '▲' : '▼'}
                </span>
                {category.categoryName}
            </div>
            {/* Render services only if the category is expanded */}
            {expandedCategoryId === category.servicecategoryID && services.length > 0 && (
                <div style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '10px' ,backgroundColor:' #1c4c49'}}>
                    {services.map(service => (
                        <div 
                            key={service.ServiceID} 
                            className="service-details" 
                            style={{ 
                                margin: '5px 0', 
                                cursor: 'pointer', 
                                background: selectedService.some(selected => selected.ServiceID === service.ServiceID) ? '#d1e7dd' : '#fff', // Highlight selected service
                                padding: '5px', 
                                border: '1px solid #ccc' 
                            }}
                        >
                            <input 
                                type="checkbox" 
                                checked={selectedService.some(selected => selected.ServiceID === service.ServiceID)} 
                                onChange={() => handleServiceSelect(service)} 
                            />
                            <strong style={{ marginLeft: '5px' }}>{service.ServiceName}</strong>
                        </div>
                    ))}
                </div>
            )}
        </div>
    ))}
</div>

            <div style={{ maxHeight: '100px', overflowY: 'auto' }}>

            {selectedService.length > 0 && (
                <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc' }}>
                    <h6>الخدمات المختارة:</h6>
                    {selectedService.map(service => (
                        <div key={service.ServiceID}>
                            <strong>{service.ServiceName}</strong>
                        </div>
                    ))}
                </div>
            )}
            {expandedCategoryId && services.length === 0 && (
                <p>لا تتوفر خدمات لهذه الفئة.</p>
            )}
                </div>
                </div>
        <div className="col-xl-6">
  
        
        <label className="form-label mt-4" style={{ whiteSpace: "nowrap" }}>اختر قطع الغيار:</label>
               <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
    <form onSubmit={handleSubmit}>
        {/* Display part classes */}
        {partClasses.map(partClass => (
            <div key={partClass.PartClassID}>
                <div
                    onClick={() => handlePartClassChange(partClass)}
                    style={{ 
                      //  color:'white',
                        cursor: 'pointer', 
                        margin: '10px 0', 
                        padding: '10px', 
                        border: '1px solid #ccc', 
                     //   background: expandedPartClassId === partClass.PartClassID ?  'rgb(37, 50, 78);' :' rgb(24, 34, 55)'// Highlight if expanded
                    }}
                ><span style={{ marginleft: '10px' }}>
                {expandedPartClassId === partClass.PartClassID ? '▲' : '▼'}
            </span>
                    {partClass.PartClassName}
                </div>

                {/* Render parts only if the part class is expanded */}
                {expandedPartClassId === partClass.PartClassID && parts.length > 0 && (
                    <div style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '10px',backgroundColor:' #1c4c49' }}>
                        {parts.map(part => (
                            <div 
                                key={part.PartID} 
                                className="part-details" 
                                style={{ 
                                    margin: '5px 0', 
                                    padding: '5px', 
                                    border: '1px solid #ccc' ,
              background: selectedParts.some(selected => selected.PartID === part.PartID) ? '#d1e7dd' : '#fff', // Highlight selected service

                                }}
                            >
                                <input 
                                    type="checkbox" 
                                    checked={selectedParts.some(selected => selected.PartID === part.PartID)} 
                                    onChange={() => handlePartSelect(part)} 
                                />
                                <strong style={{ marginLeft: '5px' }}>{part.PartName}</strong>

                                {/* Quantity Input for each part */}
                                {selectedParts.some(selected => selected.PartID === part.PartID) && (
                                    <input 
                                        type="number" 
                                        className="form-control" 
                                        value={getPartQuantity(part.PartID)} // getPartQuantity will return the current quantity for the part
                                        onChange={(e) => handleQuantityChange(part.PartID, e.target.value)} 
                                        min="1"
                                        style={{ width: '100px', marginLeft: '10px', display: 'inline-block' }}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        ))}

        {/* Submit button */}
     </form>

</div>

<div style={{ maxHeight: '100px', overflowY: 'auto' }}>
     {selectedParts.length > 0 && (
        <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc' }}>
            <h6>قطع الغيار المختارة:</h6>
            {selectedParts.map(part => (
                <div key={part.PartID}>
                    <strong>{part.PartName}</strong> - عدد: {part.quantity}
                </div>
            ))}
        </div>
    )}

    {/* No parts available message */}
    {expandedPartClassId && parts.length === 0 && (
        <p>لا تتوفر قطع غيار لهذه الفئة.</p>
    )}
</div>
        </div>
        
        
        
        </div>

 </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">حفظ</button>
            <button type="button" className="btn btn-danger " onClick={()=> setPartModal(false)}>الغاء</button>

          </div>
        </form>
      </div>
      <ToastContainer />
    </Modal>
    <InviteCustomer31
        ref={invite31} data={report}
      />
      <InviteCustomer3
        ref={invite3} data={report}
      />
    </>
    )
})

export default CreateVehicleRepairRecord;
